module.exports = __webpack_public_path__ + "static/media/sub-weapon.1c63070a.png";